import { useMemo, useState } from "react";
import { Box, Typography } from "@mui/material";
import { useMutation } from "@apollo/client";
import { ReportUnReview, ReportReview } from "../../apollo-client/api-query";

const REVIEWS_STATUS = [
  {
    title: 'Passed',
    value: true,
  },
  {
    title: 'Not passed',
    value: false 
  }
]

export default function ReviewSwitch({ reportId, needsReview = false, isReadonly = false, refetchReports }) {
  const [reviewReport, { loading: loadingReviewReport } ] = useMutation(ReportReview, {fetchPolicy: 'network-only'})
  const [unReviewReport, { loading: loadingUnReviewReport }] = useMutation(ReportUnReview, {fetchPolicy: 'network-only'})

  const [selected, setSelected] = useState(REVIEWS_STATUS[0].value)

  useMemo(() => setSelected(!needsReview), [needsReview])

  const isMutating = loadingReviewReport || loadingUnReviewReport

  const handleChange = async () => {
    if (isReadonly || isMutating) {
      return false
    }
    try {
      const variables = {
        variables: {
          reportId: reportId
        }
      }
      if (!selected) await reviewReport(variables)
      else await unReviewReport(variables)
      refetchReports()
    } catch (e) {
      console.error('[ReviewSwitch] mutation failed:', e?.message)
      refetchReports()
    }
  }

  return (
    <Box 
      sx={{
        bgcolor: selected ? 'primary.mediumGreen' : 'primary.mediumGray',
        border: '0px solid',
        borderRadius: '40px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: isReadonly ? 'center' : 'space-between',
        cursor: isReadonly ? 'default' : isMutating ? 'wait' : 'pointer',
        opacity: isMutating ? 0.6 : 1,
        height: '31px',
        width: !selected ? '129px' : '98px',
        padding: selected ? '4px 4px 4px 8px' : '4px 8px 4px 4px',
      }}
      onClick={handleChange}
    >
      {REVIEWS_STATUS.map(option => (
        <Box
          key={option.title}
          sx={isReadonly ? {}: {
            width: !selected === option.value ? '22px' : 'auto',
            height: !selected === option.value ? '22px' : '100%',
            borderRadius: !selected === option.value ? '50%' : '0px',
            textAlign: 'center',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            background: !selected === option.value ? 'white' : 'transparent',
          }}
        >
          <Typography
            key={option.value}
            variant="h4"
            sx={{
              color: 'primary.white',
              whiteSpace: 'nowrap',
              display: !selected === option.value ? 'none' : 'block',
            }}
          >
            {option.title}
          </Typography>
        </Box>
      ))}
    </Box>
  )
}